module.exports = __webpack_public_path__ + "img/7_166.add37665.png";